export const MEDIC_SPECIALITY_TRAUMATOLOGIA = 'TRAUMATOLOGIA';
export const MEDIC_SPECIALITY_PEDIATRIA = 'PEDIATRIA';
export const MEDIC_SPECIALITY_OCULISTA = 'OCULISTA';
export const MEDIC_SPECIALITY_CARDIOLOGIA = 'CARDIOLOGIA';
